import Api from "@/services/api";
import { CalendarData, SessionTemplate } from "./types";

export async function getSession(id: string): Promise<SessionTemplate> {
    return new Promise((resolve, reject) => {
        Api.get(`/session/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function createSession(model: SessionTemplate): Promise<string> {
    return new Promise((resolve, reject) => {
        Api.post("/session", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function updateSession(model: SessionTemplate): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.put("/session", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function loadAppointments(model: any): Promise<CalendarData[]> {
    return new Promise((resolve, reject) => {
        $.ajax({
            url: "http://localhost:8000/api/appointments",
            type: "GET",
            dataType: "json",
            data: model,
            success: (data: any) => {
                resolve(data);
            },
            error: error => {
                reject(error);
                console.log("Error.", "An error occoured getting data.");
            }
        });
    });
}

export async function getVideoPort(): Promise<Number> {
    return new Promise((resolve, reject) => {
        try {
            $.ajax({
                url: "http://localhost:9002/api/videoswitch/getport",
                type: "GET",
                dataType: "json",
                success: function (data: any) {
                    resolve(data);
                },
                error: error => {
                    reject(error);
                }
            });
        } catch (e) {

        }
    });
}
export async function setVideoPort(portNumber: number): Promise<Boolean> {
    return new Promise((resolve, reject) => {
        $.ajax({
            url: "http://localhost:9002/api/videoswitch/setport",
            type: "GET",
            dataType: "json",
            data: { portNumber: portNumber },
            success: (data: any) => {
                resolve(data);
            },
            error: error => {
                reject(error);
            }
        });
    });
}

export async function setVideoSwitchOFF() {
    return new Promise((resolve, reject) => {
        $.ajax({
            url: "http://localhost:9002/api/videoswitch/turnoff",
            type: "GET",
            dataType: "json",
            success: data => {
                resolve(data);
            },
            error: error => {
                reject(error);
            }
        });
    });
}

export async function setVideoSwitchON() {
    return new Promise((resolve, reject) => {
        $.ajax({
            url: "http://localhost:9002/api/videoswitch/turnon",
            type: "GET",
            dataType: "json",
            success: data => {
                resolve(data);
            },
            error: error => {
                reject(error);
            }
        });
    });
}

export async function getVideoSwithStatus() {
    return new Promise((resolve, reject) => {
        $.ajax({
            url: "http://localhost:9002/api/videoswitch/getstatus",
            type: "GET",
            dataType: "json",
            success: data => {
                resolve(data);
            },
            error: error => {
                reject(error);
            }
        });
    });
}
export async function setScreenON() {
    return new Promise((resolve, reject) => {
        $.ajax({
            url: "http://localhost:9006/api/display/turnon",
            type: "GET",
            dataType: "json",
            success: data => {
                resolve(data);
            },
            error: error => {
                reject(error);
            }
        });
    });
}

export async function setScreenOFF() {
    return new Promise((resolve, reject) => {
        $.ajax({
            url: "http://localhost:9006/api/display/turnoff",
            type: "GET",
            dataType: "json",
            success: data => {
                resolve(data);
            },
            error: error => {
                reject(error);
            }
        });
    });
}
